import React from 'react';
import LongText from '../Elements/LongText';

export default class OpenAssignmentItem {
  constructor(item) {
    if (item === undefined) {
      this.ClientName = '';
      this.ApolloSurveyId = '';
      this.LocationName = '';
      this.Country = '';
      this.ProjectName = '';
      this.ProjectId = '';
      this.ApolloId = '';
      this.DueDate = '';
      this.WaveName = '';
      this.Scheduler = '';
      return;
    }
    this.ClientName = item.clientName;
    this.ApolloSurveyId = item.apolloSurveyId;
    this.LocationName = item.locationName;
    this.Country = item.country;
    this.ProjectName = item.projectName;
    this.ProjectId = item.projectId;
    this.ApolloId = item.apolloId;
    this.DueDate = item.dueDate;
    this.WaveName = item.waveName;
    this.Scheduler = item.scheduler;
  }

  static MoneyFields = [];
  static DateFields = ['DueDate'];

  static Currency() {
    return '';
  }

  static FieldsToShowInDataTable() {
    return [
      { label: 'Client', orderById: 'ClientName', data: OpenAssignmentItem.getClientNameCellContent, minWidth: 200 },
      { label: 'Survey ID', orderById: 'ApolloSurveyId', data: 'ApolloSurveyId', minWidth: 40 },
      {
        label: 'Location',
        orderById: 'LocationName',
        data: OpenAssignmentItem.getLocationNameCellContent,
        minWidth: 200
      },
      { label: 'Country', orderById: 'Country', data: 'Country', minWidth: 10 },
      { label: 'Project', orderById: 'ProjectName', data: OpenAssignmentItem.getProjectNameCellContent, minWidth: 200 },
      { label: 'Project ID', orderById: 'ProjectId', data: 'ProjectId', minWidth: 40 },
      { label: 'Apollo ID', orderById: 'ApolloId', data: 'ApolloId', minWidth: 40 },
      { label: 'Due Date', orderById: 'DueDate', data: 'DueDate', minWidth: 60 },
      { label: 'Wave', orderById: 'WaveName', data: OpenAssignmentItem.getWaveNameCellContent, minWidth: 100 },
      { label: 'Scheduler', orderById: 'Scheduler', data: OpenAssignmentItem.getSchedulerCellContent, minWidth: 100 }
    ];
  }

  static getClientNameCellContent(item) {
    return <LongText text={item.ClientName ? item.ClientName : ' '} maxLength={50} />;
  }

  static getLocationNameCellContent(item) {
    return <LongText text={item.LocationName ? item.LocationName : ' '} maxLength={50} />;
  }

  static getProjectNameCellContent(item) {
    return <LongText text={item.ProjectName ? item.ProjectName : ' '} maxLength={50} />;
  }

  static getWaveNameCellContent(item) {
    return <LongText text={item.WaveName ? item.WaveName : ' '} maxLength={50} />;
  }

  static getSchedulerCellContent(item) {
    return <LongText text={item.Scheduler ? item.Scheduler : ' '} maxLength={50} />;
  }
}
